import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { XCircle, RefreshCw } from 'lucide-react';
import api from '@/lib/axios';

/**
 * Página de cancelamento do pagamento.
 * Oferece retry do checkout para a mesma publicação.
 */
export default function MarketplacePagamentoCancelado() {
  const [params] = useSearchParams();
  const publicacaoId = params.get('publicacao_id');
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState('');

  const retry = async () => {
    if (!publicacaoId) return;
    setLoading(true);
    setError('');
    try {
      const res = await api.post(`/marketplace/publicacoes/${publicacaoId}/checkout`, {
        origin_url: window.location.origin,
      });
      if (res.data?.checkout_url) {
        window.location.href = res.data.checkout_url;
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Não foi possível abrir o pagamento.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen bg-gradient-to-br from-emerald-50 via-cyan-50 to-slate-100 flex items-center justify-center p-6"
      data-testid="marketplace-payment-cancel-page"
    >
      <div className="w-full max-w-lg rounded-3xl border border-slate-200 bg-white p-8 shadow-sm text-center">
        <XCircle className="mx-auto h-14 w-14 text-amber-500" />
        <h1 className="mt-4 text-2xl font-bold text-slate-900">Pagamento cancelado</h1>
        <p className="mt-2 text-sm text-slate-700">
          O pagamento foi cancelado antes de ser concluído. O seu anúncio foi guardado mas ainda
          <strong> não está activo</strong>. Pode tentar pagar de novo agora.
        </p>
        {error && (
          <p className="mt-3 rounded-lg bg-red-50 border border-red-200 px-3 py-2 text-sm text-red-700">
            {error}
          </p>
        )}
        <div className="mt-6 flex justify-center gap-3">
          {publicacaoId && (
            <button
              onClick={retry}
              disabled={loading}
              className="inline-flex items-center gap-2 rounded-xl bg-emerald-600 px-5 py-2 text-sm font-semibold text-white hover:bg-emerald-700 disabled:bg-slate-400"
              data-testid="marketplace-payment-retry-btn"
            >
              <RefreshCw className={`h-4 w-4 ${loading ? 'animate-spin' : ''}`} />
              {loading ? 'A abrir...' : 'Tentar pagar novamente'}
            </button>
          )}
          <Link
            to="/marketplace"
            className="inline-block rounded-xl border border-slate-300 px-5 py-2 text-sm text-slate-700 hover:bg-slate-50"
          >
            Voltar ao Marketplace
          </Link>
        </div>
      </div>
    </div>
  );
}
